import { createContext, useContext, useReducer } from 'react';
import {
  initialState,
  ProductPaymentAdditionalInformationReducer,
} from '../reducer/ProductPaymentAdditionalInformationReducer';

const ProductPaymentAdditionalInformationStateContext = createContext();
const ProductPaymentAdditionalInformationDispatchContext = createContext();

export const ProductPaymentAdditionalInformationProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    ProductPaymentAdditionalInformationReducer,
    initialState
  );

  return (
    <ProductPaymentAdditionalInformationStateContext.Provider value={state}>
      <ProductPaymentAdditionalInformationDispatchContext.Provider
        value={dispatch}
      >
        {children}
      </ProductPaymentAdditionalInformationDispatchContext.Provider>
    </ProductPaymentAdditionalInformationStateContext.Provider>
  );
};

export const useProductPaymentAdditionalInformationState = () => {
  const context = useContext(ProductPaymentAdditionalInformationStateContext);

  if (!context)
    throw Error(
      'useProductPaymentAdditionalInformation는 ProductPaymentAdditionalInformationProvider 내에서 사용해야 합니다.'
    );
  return context;
};

export const useProductPaymentAdditionalInformationDispatch = () => {
  const context = useContext(
    ProductPaymentAdditionalInformationDispatchContext
  );

  if (!context)
    throw Error(
      'useProductPaymentAdditionalInformationDispatch는 ProductPaymentAdditionalInformationProvider 내에서 사용해야 합니다.'
    );
  return context;
};
